import React, {Component} from "react";
import {connect} from "react-redux";
import {getInfo} from "../../redux/actions/user";
import Loading from "../../components/Loading";
import {NavLink, withRouter} from "react-router-dom";
import lodash from "lodash";
import {LOCAL} from "../../constants/local";

class UserMenu extends Component {

	componentWillMount() {
		this.props.onGetInfoUser();
	}

	checkActive(match) {
		if ( !this.props.location ) {
			return false;
		}

		return lodash.indexOf(match, this.props.location.pathname) !== -1;
	}

	render() {
		const {user} = this.props;

		if ( user.fetching ) {
			return <Loading/>;
		}

		const {cash} = user;
		
		return (
			<div className="body__container__side-left bg-gray">
				<div className="profile-menu">
					<div className="profile-menu__balance">
						<div className="header">Личный кабинет</div>
						<div className="data">
							<div className="cl-gray">Доступный баланс</div>
							<div>{user.info.money} {LOCAL.currency}</div>
						</div>
						<div className="data">
							<div className="cl-gray">№ счёта</div>
							<div>{user.info.id}</div>
						</div>
						<div className="data">
							<div className="cl-gray">В игре</div>
							<div>{cash.in_game} {LOCAL.currency}</div>
						</div>
					</div>
					<div className="profile-menu__list">
						<ul>
							{/*{user.info.passport.length === 0 &&*/}
							{/*<li className={this.checkActive(['/user/passport']) ? 'active' : ''}*/}
							    {/*style={{border:'2px dashed #0a9f30'}}>*/}
								{/*<NavLink exact to={'/user/passport'}>*/}
									{/*<i className="far fa-file-alt"></i>&nbsp;*/}
									{/*<span>Загрузить документ</span>*/}
								{/*</NavLink>*/}
							{/*</li>}*/}
							<li className={this.checkActive(['/user/pay', '/user/take-money']) ? 'active' : ''}>
								<NavLink exact to={'/user/pay'}>
									<i className="fas fa-dollar-sign"></i>&nbsp;
									<span>Ввод/вывод средств</span>
								</NavLink>
							</li>
							<li className={this.checkActive(['/user/payments']) ? 'active' : ''}>
								<NavLink exact to={'/user/payments'}><i className="fas fa-hourglass-half"></i>&nbsp;
									<span>История платежей</span>
								</NavLink>
							</li>
							<li className={this.checkActive(['/user/history']) ? 'active' : ''}>
								<NavLink to={'/user/history'}>
									<i className="far fa-calendar-alt"></i>&nbsp;<span>История ставок</span>
								</NavLink>
							</li>
							<li className={this.checkActive(['/user/password']) ? 'active' : ''}>
								<NavLink exact to={'/user/password'}><i className="fas fa-unlock-alt"></i>&nbsp;
									<span>Изменение пароля</span>
								</NavLink>
							</li>
							<li className={this.checkActive(['/user/data']) ? 'active' : ''}>
								<NavLink exact to={'/user/data'}>
									<i className="far fa-address-card"></i>&nbsp;<span>Личные данные</span>
								</NavLink>
							</li>
						</ul>
					</div>

				</div>
			</div>
		);
	}
}

export default withRouter(
	connect(
		state => ({
			user : state.user
		}),
		dispatch => ({
			onGetInfoUser : () => {
				dispatch(getInfo());
			},
		})
	)(UserMenu)
);


// WEBPACK FOOTER //
// ./src/app/pages/User/UserMenu.js